import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details_container" }
const _hoisted_2 = { class: "qCard" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "card_details" }
const _hoisted_5 = { class: "qCard" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "card_details" }
const _hoisted_8 = { class: "qCard" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "card_details" }
const _hoisted_11 = { class: "qCard" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "card_details" }
const _hoisted_14 = { class: "qCard" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "card_details" }

import { ref } from 'vue';
import GraphCard from './graphCard.vue';
import RuleCard from './ruleCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'faqView',
  setup(__props) {

const resData = ref({
    details: [],
    page: 1,
    summary: {
        commission: 0,
        commission_rate: 0,
        total_bet: 0,
    },
    tip: "",
    totalPage: 1
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('agent.faqTitle1')) + " ", 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "688V", -1)),
        _cache[1] || (_cache[1] = _createTextVNode(" ?"))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("span", null, "688V", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('agent.faqContent1')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('agent.faqTitle2')), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('agent.faqContent2')), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('agent.faqTitle3')), 1),
      _createElementVNode("div", _hoisted_10, [
        _createTextVNode(_toDisplayString(_ctx.$t('agent.faqContent3')) + " ", 1),
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "688V", -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('agent.faqContent3Sub')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('agent.faqTitle4')), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('agent.faqContent4')), 1)
    ]),
    _createVNode(GraphCard, { isShowNotice: true }),
    _createVNode(RuleCard),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('agent.definition')), 1),
      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('agent.definitionContent')), 1)
    ])
  ]))
}
}

})